export default __webpack_public_path__ + "static/media/Gopal_Kumarappan.1d12695f.jpg";